import React from 'react';

import {SearchFields} from '../SearchFields';

import {useComponent} from './hooks';

import './SearchForm.less';

function SearchForm(props) {
    const {
        className,
        onSubmit
    } = useComponent(props);

    return (
        <form className={className} onSubmit={onSubmit}>
            <SearchFields/>
        </form>
    );
}

export default SearchForm;
export {SearchForm};
